export const INCART_URL = '/shop/api/ncart/fetch-in-cart/';
export const ITEMS_URL = '/shop/api/ncart/fetch-dropdown/';
export const DEL_ITEMS_URL = '/shop/api/ncart/';
export const ADD_URL = '/shop/api/ncart/add/';